import * as RecnService from '@services/recn-service'
import Microform from './Microform'
import ApplePay from './ApplePay'

var mode
var associationId
var paymentTypes = []

var microform = new Microform()
var applePay = new ApplePay()

var digitalPaymentWindow

export default class NarPaymentClient {
  constructer() { }

  init(options) {
    return new Promise((resolve, reject) => {
      //Set default mode to 'prod'
      options.mode = options.mode || 'prod'

      //Cache options
      mode = options.mode
      associationId = options.associationId

      initPaymentTypes()
        .then(() => {
          options.paymentTypes = paymentTypes

          // Initialize tokenizer and digital wallets after getting accepted Payment Types
          return Promise.all([
            microform.init(options),
            applePay.init(options)
          ])
        })
        .then(() => {
          resolve({
            paymentTypes: paymentTypes
          })
        })     
        .catch(error => {
          reject(error)
        })
    })
  }

  tokenizeCard(options) {
    return microform.tokenizeCard(options)
  }

  isApplePaySupported() {
    return applePay.isActive()
  }

  isApplePayActive() {
    return applePay.isActive()
  }

  openApplePay(amount, displayName) {
    return applePay.createSession(amount, displayName)
  }

  isDigitalPaymentSupported() {
    return applePay.isActive()
  }

  isDigitalPaymentPopupSupported() {
    //Check that association supports Digital payments
    if (paymentTypes.indexOf('Digital') < 0) {
      return false
    }

    //Now go through each Digital payment type to see if any are supported
    if (applePay.isOnSupportedDevice()) {
      return true
    }

    return false
  }

  openDigitalPaymentsPopup(amount) {
    return new Promise((resolve, reject) => {
      try {
        //Block the current page
        maskPage()

        //Reset window if open
        if (digitalPaymentWindow && !digitalPaymentWindow.closed) {
          digitalPaymentWindow.close()
        }

        var baseUrl = mode === 'prod' ? process.env.HOSTED_PAGE_URL_PROD : process.env.HOSTED_PAGE_URL_NONPROD

        //Open popup window
        digitalPaymentWindow = popupCenter(
          `${baseUrl}/digital-payments.html?associationId=${associationId}&amount=${amount}`,
          'DigitalPayments',
          400, 400)

        //Make sure the popup is always in focus when open
        window.onfocus = () => {
          if (digitalPaymentWindow && !digitalPaymentWindow.closed) {
            digitalPaymentWindow.focus()
          }
        }

        //Listen for messages recieved from the popup
        window.addEventListener('message', (e) => {
          if (e.data) {
            if (e.data.error) {
              reject(e.data.error)
            } else if (e.data.tokenData) {
              let tokenData = e.data.tokenData

              resolve(tokenData)
            }
          }
        } , false)

        // Poll child window 2x per second to check if it has closed to
        // remove the page mask and reject the Promise
        var timer = setInterval(() => {
          if (!digitalPaymentWindow || digitalPaymentWindow.closed) {
            clearInterval(timer)
            unmaskPage()

            reject('cancelled')
          }
        }, 500)
      } catch (e) {
        reject(e.message)
        unmaskPage()
      }
    })
  }

  get mode() {
    return mode
  }

  get associationId() {
    return associationId
  }

  get paymentTypes() {
    return paymentTypes.slice()
  }
}

/***********************/
/** Private Functions **/
/***********************/

function initPaymentTypes() {
  return new Promise((resolve, reject) => {
    if (!associationId) {
      reject('Missing {associationId}')
    } else {
      RecnService.paymentTypes(mode, associationId)
        .then(data => {
          paymentTypes = data
        })
        .catch(error => {
          log.error('Error getting accepted Payment Types', error)
        })
        .finally(() => {
          resolve()
        })
    }
  })
}

var maskElement

function maskPage() {
  if (!maskElement) {
    maskElement = document.createElement('div')
    maskElement.style = 'z-index: 1000; border: none; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background-color: rgb(0, 0, 0); opacity: 0.6; cursor: pointer; position: fixed;'
    document.getElementsByTagName('body')[0].appendChild(maskElement)
  }
}

function unmaskPage() {
  if (maskElement) {
    maskElement.remove()
    maskElement = undefined
  }
}

function popupCenter(url, title, w, h) {
  // Fixes dual-screen position                         Most browsers      Firefox
  var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left
  var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top

  var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
  var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height

  var left = ((width / 2) - (w / 2)) + dualScreenLeft
  var top = ((height / 2) - (h / 2)) + dualScreenTop
  var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left)

  //Fix if above popup fails for some reason
  if (!newWindow) {
    newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h)
  }

  // Puts focus on the newWindow
  if (window.focus) {
    newWindow.focus()
  }

  return newWindow
}
